import * as React from "react";
const SvgFiRrLeafOak = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-leaf-oak_svg__a)">
      <path
        fill="#062147"
        d="M22.643 7.242q.044-.059.142-.158a4.12 4.12 0 0 0 1.216-2.934 4.12 4.12 0 0 0-1.216-2.935A4.12 4.12 0 0 0 19.85-.001c-1.11 0-2.15.432-2.934 1.215a2 2 0 0 1-.158.143 3 3 0 0 1-.163-.141c-.905-.819-1.9-1.217-3.045-1.217a4.12 4.12 0 0 0-4.117 4.204c-.204-.019-.9-.004-.9-.004-2.387 0-4.333 1.916-4.383 4.32-.05.017-.316.092-.384.116A4.16 4.16 0 0 0 1 12.548c0 1.617 1.922 4.655 2.916 6.12L.293 22.291a.999.999 0 1 0 1.414 1.414l3.623-3.623c1.465.995 4.503 2.916 6.12 2.916a4.16 4.16 0 0 0 3.914-2.767c.023-.066.1-.333.116-.384a4.386 4.386 0 0 0 4.32-4.381c0-.229-.017-.505-.038-.78l.087-.089A4.154 4.154 0 0 0 24 10.448c0-1.144-.397-2.14-1.217-3.045a3 3 0 0 1-.14-.163zm-1.342 1.505c.49.542.7 1.052.7 1.703a2.155 2.155 0 0 1-2.169 2.149c-.576 0-1.13.245-1.52.67a2.09 2.09 0 0 0-.543 1.577c.018.219.031.44.031.622a2.384 2.384 0 0 1-2.38 2.381c-.969 0-1.64.645-1.94 1.717A2.16 2.16 0 0 1 11.45 21c-.742 0-2.82-1.129-4.678-2.358l6.935-6.935a1 1 0 1 0-1.414-1.414L5.36 17.228c-1.23-1.857-2.358-3.936-2.358-4.678 0-.91.576-1.725 1.433-2.027 1.072-.301 1.718-.974 1.718-1.941a2.384 2.384 0 0 1 2.381-2.381s.595-.016.737-.003c.566.05 1.093-.13 1.488-.495.414-.381.643-.926.644-1.552 0-1.186.964-2.15 2.15-2.15.65 0 1.16.209 1.702.699.39.354 1.575 1.43 3.077-.069.813-.813 2.228-.812 3.04 0 .406.406.63.945.63 1.521s-.224 1.113-.63 1.52c-1.498 1.5-.423 2.688-.069 3.077z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-leaf-oak_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLeafOak;
